<template>
  <div class="awl-sidenav--item" :class="{ active: isActive }">
    <!-- TODO: i parent dei link in stato active dovrebbero ereditare la classe active -->
    <app-router-link v-if="isLink && useAppRouterLink" class="awl-sidenav--link" :to="link.to" v-close-menu>
      <i class="awl-sidenav--icon" :class="link.icon"></i>
      <span v-if="!showIconsOnly" class="ml-3">
        {{ link.name }}
      </span>
    </app-router-link>
    <router-link v-else-if="isLink" class="awl-sidenav--link" :to="link.to" v-close-menu>
      <i class="awl-sidenav--icon" :class="link.icon"></i>
      <span v-if="!showIconsOnly" class="ml-3">
        {{ link.name }}
      </span>
    </router-link>
    <p v-else-if="hasChildren" class="awl-sidenav--link" @click="toggleChildren">
      <i class="awl-sidenav--icon" :class="link.icon" />
      <span class="flex-grow-1 ml-3" v-if="!showIconsOnly">
          {{ link.name }}
        </span>
      <i class="awl-sidenav--chevron fa-xs fas" :class="[ showChildrenLinks ? 'fa-chevron-down' : 'fa-chevron-right' ]" v-if="!showIconsOnly"></i>
    </p>
    <p v-else class="awl-sidenav--link">
      <i class="awl-sidenav--icon" :class="link.icon"></i>
      <span v-if="!showIconsOnly">
        {{ link.name }}
      </span>
    </p>

    <ul v-if="hasChildren && !showIconsOnly && showChildrenLinks" class="link-children px-4 ">
      <li v-for="(child, i) in link.children" :key="i" class="fade-in" :style="{ animationDelay: i*.12 + 's' }">
        <span v-if="child.hide"></span>
        <app-router-link v-else-if="child.appLink" :to="child.to" :class="{ 'px-4' : !showIconsOnly }" class="link py-1 d-block" v-close-menu>
          <span v-if="!showIconsOnly">
            {{ child.name }}
          </span>
        </app-router-link>
        <router-link v-else :to="child.to" :class="{ 'px-4' : !showIconsOnly }" class="link py-1 d-block" v-close-menu>
          <span v-if="!showIconsOnly">
            {{ child.name }}
          </span>
        </router-link>
      </li>
    </ul>

    <div v-if="showIconsOnly" class="hover-link-children position-absolute shadow w-auto bg-white">
      <app-router-link v-if="isLink && useAppRouterLink" class="list-header text-primary font-weight-bold px-4 py-3 mb-0" :to="link.to" v-close-menu :class="{'border-bottom': hasChildren}">
        {{ link.name }}
      </app-router-link>
      <router-link v-if="isLink && hasChildren" class="list-header text-primary font-weight-bold px-4 py-3 mb-0" :to="link.to" v-close-menu :class="{'border-bottom': hasChildren}">
        {{ link.name }}
      </router-link>
      <p v-else-if="hasChildren" class="list-header text-primary font-weight-bold px-4 py-3 border-bottom mb-0">
        {{ link.name }}
      </p>
      <ul v-if="hasChildren" class="link-children px-4 pt-2">
        <li v-for="(child, i) in link.children" :key="i">
          <span v-if="child.hide"></span>
          <router-link v-else-if="child.appLink" :to="child.to" class="py-2 text-primary d-block" v-close-menu>
            {{ child.name }}
          </router-link>
          <router-link v-else :to="child.to" class="py-2 text-primary d-block" v-close-menu>
            {{ child.name }}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import closeMenuDirective from '@/libs/Sidebar/directives/closeMenu.js';

export default {
  components: {
    AppRouterLink: () => import('@/views/components/Layout/AppRouterLink.vue'),
  },
  directives: {
    closeMenu: closeMenuDirective,
  },
  props: {
    link: {
      type: Object,
      required: true,
    },
    showIconsOnly: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showChildrenLinks: false,
    };
  },
  computed: {
    hasChildren () {
      return this.link?.children?.length > 0;
    },
    isLink () {
      return !!this.link?.to;
    },
    useAppRouterLink () {
      return !!this.link?.appLink;
    },
    isActive () {
      if (this.link?.active) {
        return true;
      }

      if (this.isLink && this.$route?.name === this.link?.to?.name) {
        return true;
      }

      return false;
    },
  },
  methods: {
    toggleChildren () {
      this.showChildrenLinks = !this.showChildrenLinks;
    },
  },
};

</script>

<style lang="scss">

$primary: blue !default;
$white: #fff !default;
$sidebar-items-background-color: transparent !default;
$sidebar-items-text-color: #333 !default;
$sidebar-items-hover-background-color: #333 !default;
$sidebar-items-hover-text-color: #eee !default;

.awl-sidenav--item {
  position: relative;
  background: $sidebar-items-background-color;
  color: $sidebar-items-text-color;
  border-left: 5px solid $primary;
  display: block;
  text-decoration: none;
  transition: background-color 0.3s ease-in-out;

  @include media-breakpoint-down(sm) {
    border-bottom-right-radius: 100px;
    border-top-right-radius: 100px;
  }

  & > p {
    margin-bottom: 0;
  }

  .hover-link-children {
    border-bottom-right-radius: 6px;
    border-top-right-radius: 6px;
    left: 100%;
    min-width: 220px;
    top: 0;
    visibility: hidden;

  }

  &:hover {
    .hover-link-children {
      visibility: visible;
    }
  }

  .awl-sidenav--link {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 1rem 1.5rem;
    padding-left: calc(1.5rem - 3px);
    color: $white;
  }

  .awl-sidenav--icon {
    align-items: flex-end;
    color: $sidebar-items-text-color;
    font-size: 20px;
    display: inline-flex;
    justify-content: center;
    width: 28px;
  }

  .awl-sidenav--chevron {
    margin-left: .75rem;
    color: $white;
  }

  &.active {
    background: $white;
    color: $primary;
    font-weight: bold;
    border-left-color: $primary;

    i {
      color: $primary;
    }

    .awl-sidenav--link {
      color: $primary;
    }
  }
}

</style>
